__turbopack_context__.v({
  "className": "inter_tight_4a69c155-module___YxWmq__className",
});
